import React from 'react'
import { ArrayInput, FormDataConsumer, SimpleFormIterator } from 'react-admin'
import { FormDataConsumerProps } from 'types/common'
import DayMonthInput from 'ui-shared/WrappedInputs/DayMonthInput'
import DayMonthField from 'ui-shared/WrappedInputs/DayMonthField'
import { addDaysToDayMonthLabel } from 'services/utils/date'
import { getIndicesFromGetSourceString } from 'services/hooks/useKArrayInput'
import {
  BudgetDateRange,
  Organization,
} from 'services/api/entities/crm/organizations/types/internal/organization-model'

const BudgetDateRangeInput: React.FC = () => {
  return (
    <ArrayInput source="budgetDateRange">
      <SimpleFormIterator disableReordering>
        <FormDataConsumer>
          {({
            formData,
            getSource,
          }: FormDataConsumerProps<Organization, Partial<BudgetDateRange>>) => {
            const index = getIndicesFromGetSourceString(getSource!(''))?.[0]

            const previousRange = formData.budgetDateRange?.[index - 1]
            const isFirst = index === 0

            const fieldValue =
              previousRange?.budgetSpentDateTo &&
              addDaysToDayMonthLabel(previousRange.budgetSpentDateTo, 1)

            // ra4Migration broke this component, check it and the used getIndicesFromGetSourceString function, and restore them

            return (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  width: '100%',
                }}
              >
                {isFirst ? (
                  <DayMonthInput
                    source={getSource!('budgetSpentDateFrom')}
                    label="form.fields.from"
                    style={{ margin: '16px 16px 16px 0' }}
                    disabled={!isFirst}
                  />
                ) : (
                  <DayMonthField value={fieldValue} label="From" />
                )}
                <DayMonthInput
                  source={getSource!('budgetSpentDateTo')}
                  label="form.fields.to"
                  style={{ margin: '16px 0' }}
                />
              </div>
            )
          }}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  )
}

export default BudgetDateRangeInput
